<!-- Status / category pill. Tones map to the theme-aware feedback tokens so
     they read correctly in light + dark. Optional leading status dot. -->
<template>
  <span :class="cls">
    <span v-if="dot" class="size-1.5 rounded-full" :class="dotCls"></span>
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    tone?: 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';
    dot?: boolean;
  }>(),
  { tone: 'neutral', dot: false },
);

const TONES: Record<string, string> = {
  neutral: 'bg-gray-100 text-gray-600',
  brand: 'bg-brand-50 text-brand-700',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger: 'bg-danger-soft text-danger',
  info: 'bg-info-soft text-info',
};
const DOTS: Record<string, string> = {
  neutral: 'bg-gray-400',
  brand: 'bg-brand-500',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  info: 'bg-info',
};

const cls = computed(() => [
  'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium',
  TONES[props.tone],
]);
const dotCls = computed(() => DOTS[props.tone]);
</script>
